import { differenceInCalendarMonths, isValid } from "date-fns";
import { sinkingFundPayment } from "shared/sinkingFundPayment";
import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const monthsUntil = (dueDate: Date | undefined | null): number => {
	if (!dueDate || !isValid(dueDate)) return 0;
	return Math.max(0, differenceInCalendarMonths(dueDate, new Date()));
};

export const monthlyContribution = (
	savingsTarget: number,
	dueDate: Date | undefined | null,
	annualRate: number = GOAL_REAL_YIELD,
): number => {
	return sinkingFundPayment(
		annualRate / 12,
		monthsUntil(dueDate),
		savingsTarget,
	);
};
